var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "both-pd-box" }, [
    _c("div", { staticClass: "flex" }, [
      _c(
        "div",
        { staticStyle: { width: "500px" } },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "新手教程图", prop: "TutorialsImage" } },
                [
                  _c(
                    "div",
                    { staticClass: "frb" },
                    [
                      _c(
                        "upload",
                        {
                          attrs: {
                            name: "TutorialsImage",
                            "img-url": _vm.ruleForm.TutorialsImage,
                          },
                          on: {
                            pictureAddress: function ($event) {
                              return _vm.onPictureAddress($event)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#f59a23",
                                "font-size": "12px",
                              },
                            },
                            [_vm._v("建议尺寸不超过750px*400px，PNG格式")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "背景色", prop: "backdropColor" } },
                [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入色值，例“#ffffff”" },
                        model: {
                          value: _vm.ruleForm.backdropColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "backdropColor", $$v)
                          },
                          expression: "ruleForm.backdropColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-color-picker", {
                        model: {
                          value: _vm.ruleForm.backdropColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "backdropColor", $$v)
                          },
                          expression: "ruleForm.backdropColor",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "观看按钮填充色",
                    prop: "watchButtonFillColor",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入色值，例“#ffffff”" },
                        model: {
                          value: _vm.ruleForm.watchButtonFillColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "watchButtonFillColor", $$v)
                          },
                          expression: "ruleForm.watchButtonFillColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-color-picker", {
                        model: {
                          value: _vm.ruleForm.watchButtonFillColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "watchButtonFillColor", $$v)
                          },
                          expression: "ruleForm.watchButtonFillColor",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "观看按钮文字色",
                    prop: "watchButtonTextColor",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入色值，例“#ffffff”" },
                        model: {
                          value: _vm.ruleForm.watchButtonTextColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "watchButtonTextColor", $$v)
                          },
                          expression: "ruleForm.watchButtonTextColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-color-picker", {
                        model: {
                          value: _vm.ruleForm.watchButtonTextColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "watchButtonTextColor", $$v)
                          },
                          expression: "ruleForm.watchButtonTextColor",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }